import { ErrorFilled } from '@carvana/purchase-icons';
import styled from 'styled-components';

export const PdfAlertContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  & > p {
    color: #e03131;
  }
`;

export const ErrorIcon = styled(ErrorFilled)`
  color: #e03131;
  height: 2rem;
  width: 2rem;
`;
